import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import Golf from "../../../assets/img/Featured/pc-golf-sheet.png";
import Book from "../../../assets/img/Featured/app-golf-booking.png";
import GuestApp from "../../../assets/img/Featured/app-golf-courses.png";
import Retail from "../../../assets/img/Featured/pc-golf-retail.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";
const ShopPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page shopPage">
            <Header />
            <div className="page-header">Golf Course</div>
            <div className="text-wrapper">
                <div className="top">
                    <div className="topic-header">Pro Shop</div>
                    <HorizontalLine />
                </div>
                <div className="std-text">
                    Ensure that you always have the perfect sleeve of
                    balls or logoed golf wear for every golfer.{'\n\n'}
                </div>
                <div className="std-text">
                    With InfoGenesis POS and Agilysys Eatec
                    procurement and inventory system, not
                    only will you have the items your guests desire,
                    but they can also seamlessly pay with credit
                    cards, gift cards or cash.
                </div>
            </div>

            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Golf - Pro Shop", "Golf");
                    addFlow("Golf");
                    navigate("/solutions/golf")}}>
                    <div className="item-head">
                        <LogoMini />
                        Golf
                    </div>
                    <img src={Golf} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Golf - Pro Shop", "Book");
                    addFlow("Book");
                    navigate("/solutions/book")}}>
                    <div className="item-head">
                        <LogoMini />
                        Book
                    </div>
                    <img src={Book} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Golf - Pro Shop", "Guest App");
                    addFlow("Guest App");
                    navigate("/solutions/guest-app")}}>
                    <div className="item-head">
                        <LogoMini />
                        Guest App
                    </div>
                    <img src={GuestApp} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Golf - Pro Shop", "Retail");
                    addFlow("Retail");
                    navigate("/solutions/retail")}}>
                    <div className="item-head">
                        <LogoMini />
                        Retail
                    </div>
                    <img src={Retail} alt="" />
                </div>
            </FeaturedSolutions>
        </div>
    )
}
export default ShopPage;